import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"

import NoResults from "./NoResults"
import Products from "./Products"
import Toolbar from "./Toolbar"
import Sidebar from "./Sidebar"
import BottomToolbar from "./BottomToolbar"
 
import SelectedFilters from "./SelectedFilters"

export default function () {
    const {
        response: { products },
        loading,
    } = useAppState()

    const foundProducts = products && products.total > 0
    const isMobile = window.innerWidth < 769;

    return (
        <div
            class={!isMobile ? "ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto" : "ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inheritns-my-0 ns-mx-auto"}
            data-nosto-element="search"
        >
            {(foundProducts || (loading && foundProducts)) && (
                <Fragment>
                    {/* <Sidebar /> */}
                    <Toolbar mobile />
                </Fragment>
            )}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box"
                style={loading && !isMobile && "position: relative; padding-top: 3rem!important"}
            >
                {loading && foundProducts ? (
                    <>
                        {/* <SelectedFilters /> */}
                        <Toolbar />
                        <Loader />
                        <Products />
                    </>
                ) : loading ? (
                    <Loader />
                ) : foundProducts ? (
                    <>
                        {/* <SelectedFilters /> */}
                        <Toolbar />
                        <Products />
                        <BottomToolbar />
                    </>
                ) : (
                    <NoResults />
                )}
            </div>
        </div>
    )
}
